import React from 'react'
import { useTranslation } from 'react-i18next';

import { PROJECT } from '../../constants';

import CreateImg1 from '../../images/vive-create-feature-a.png'
import CreateImg2 from '../../images/vive-create-feature-b.png'
import CreateImg3 from '../../images/vive-create-feature-c.png'
import VGImg1 from '../../images/vg-1.png';
import VGImg2 from '../../images/vg-2.png';
import VGImg3 from '../../images/vg-3.png';

import './keyFeature.scss';

const KeyFeature = () => {
    const { t } = useTranslation();

    const content = PROJECT === 'vg' ?
    {
        title: t('titleKeyFeature_vg'),
        img1: VGImg1,
        img2: VGImg2,
        img3: VGImg3,
        desc1: t('contentKeyFeature1_vg'),
        desc2: t('contentKeyFeature2_vg'),
        desc3: t('contentKeyFeature3_vg'),
    } :
    {
        title: t('titleKeyFeature'),
        img1: CreateImg1,
        img2: CreateImg2,
        img3: CreateImg3,
        desc1: t('contentKeyFeature1'),
        desc2: t('contentKeyFeature2'),
        desc3: t('contentKeyFeature3'),
    }

    return (
        <div id="key_feature">
            <div className="wrapper">
                <div className="title">{content.title}</div>
                <div className="content first">
                    <div className="content-text">{content.desc1}</div>
                    <img src={content.img1} alt="" className='content-image'/>
                </div>
                <div className="content-reverse">
                    <div className="content-text">{content.desc2}</div>
                    <img src={content.img2} alt="" className='content-image'/>
                </div>
                <div className="content last">
                    <div className="content-text">{content.desc3}</div>
                    <img src={content.img3} alt="" className='content-image'/>
                </div>
            </div>
        </div>
    )
}

export default KeyFeature;
